import {
  PolymorphicComponentPropWithRef,
  PolymorphicRef,
} from "@kunduz/utility-polymorphic-component";
import classNames from "classnames";
import React from "react";
import styles from "./button.module.scss";

type ButtonVariant = "primary" | "secondary" | "tertiary" | "link";
type ButtonSize = "sm" | "md" | "lg" | "xl" | "2xl";
type ButtonColor = "blue" | "gray" | "red" | "tutorGreen";

type ButtonProps<C extends React.ElementType> = PolymorphicComponentPropWithRef<
  C,
  {
    variant?: ButtonVariant | "primary";
    size?: ButtonSize | "lg";
    color: ButtonColor | "blue";
    destructive?: boolean | false;
  }
>;

type ButtonComponent = <C extends React.ElementType = "button">(
  props: ButtonProps<C>,
) => React.ReactElement | null | any;

export const Button: ButtonComponent = React.forwardRef(
  <C extends React.ElementType = "button">(
    {
      as,
      children,
      variant,
      size,
      color,
      className,
      destructive,
      ...rest
    }: ButtonProps<C>,
    ref?: PolymorphicRef<C>,
  ) => {
    const Component = as || "button";

    return (
      <Component
        ref={ref}
        {...rest}
        className={classNames(
          className,
          styles.base,
          styles[`size-${size}`],
          styles[`variant-${variant}`],
          styles[`color-${color}`],
          {
            [styles.regular]: !destructive,
            [styles.destructive]: !!destructive,
          },
        )}
      >
        {children}
      </Component>
    );
  },
);
//@ts-ignore
Button.displayName = "Button";
